import * as React from 'react';

import style from '../WFormsTableWrapper.less';

interface CreateLegendProps extends React.ClassAttributes<any> {
    data: Array<any>;
    filterData: (event: any) => void;
    delMissing?: boolean;
    dropFilter?: boolean;
    showOrigRows: boolean;
    onDeleteLeftoversChange: (val: boolean) => void;
    onShowOrigRowsChange: (val: boolean) => void;

}
interface CreateLegendState {
    forLegend: Array<any>;
    deleteLeftovers: boolean;
    selectedOption?: number;
}

export class CreateLegend extends React.Component<CreateLegendProps, CreateLegendState>  {

    constructor(props: any) {
        super(props);
        this.state = {
            forLegend: [],
            deleteLeftovers: false  // Fehlende Datensätze löschen
        };

        this.getLegendData = this.getLegendData.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        this.getLegendData();
    }

    onClick(selectedOption: number) {
        console.log('Type Select: ' + selectedOption);
        this.setState({selectedOption}, () =>  this.props.filterData(selectedOption));
    }

    render() {
        return(
        <div>
        {this.props.dropFilter &&
            <div className={style.flexItem}>
                <div>Filter Daten</div>
                <select
                    className = {style.w300}
                    value = {this.state.selectedOption ? this.state.selectedOption : 0}
                    onChange = {(evt: any) => this.onClick(+evt.target.value)}

                    >
                    {this.renderOption(this.state.forLegend)}
                </select>
        </div>}

            <ul className = {style.legendList}>
            {this.state.forLegend.map((dataLegend: any, idx: number) =>
                <li key = {'filter_' + idx} style = {dataLegend.style} onClick = {() => this.onClick(idx)} >
                    {dataLegend.status} : {dataLegend.number}
                    {this.props.delMissing && dataLegend.status === 'Fehlende' && dataLegend.number > 0 &&
                    <div className = {style.mini_info}>
                        <input
                            type='checkbox'
                            checked = {this.state.deleteLeftovers}
                            onClick = {(evt: any) => {
                                            evt.stopPropagation();
                                            this.setState({deleteLeftovers: evt.target.checked ? true : false});
                                            this.props.onDeleteLeftoversChange(evt.target.checked ? true : false);
                                        }
                                    }
                            /> Entfernen
                    </div>}
                    {dataLegend.status === 'Geändert'  && dataLegend.number > 0 &&
                    <div className = {style.mini_info}>
                        <input
                            type='checkbox'
                            checked = {this.props.showOrigRows}
                            onClick = {(evt: any) => {
                                            evt.stopPropagation();
                                            this.props.onShowOrigRowsChange(evt.target.checked ? true : false);
                                        }
                                    }
                            /> Origin.
                    </div>}
                </li>
            )}
            </ul>
        </div>
    );
    }

    getLegendData() {
        const dataIn = this.props.data;
        const forLegend: Array<any> = [];
        const status = ['Alle Daten', 'Geändert', 'Neu', 'Fehlende', 'Vorhanden', 'Ungültig', 'Formatfehler', 'Doppelt'];
        const bg = [{background: '#EEE'}, {background: '#FFFFAA'}, {background: '#AAAAFF'}, {background: '#FFAAAA'},
                    {background: '#CCFFCC'}, {background: '#880000', color: '#CCAAAA'}, {background: '#FFFFFF', color: '#880000'},
                    {background: '#444444', color: '#AAAAAA'}];
        for ( let i = 0; i < status.length; i++) {
            const n = dataIn.filter((row: any) => row.internal._diffState === i);
            if (i === 0) {
                n.length = dataIn.filter((row: any) => row.internal._diffState !== 8).length;
            }
            forLegend.push({status: status[i], number: n.length, style: bg[i]});
        }
        this.setState({forLegend});
    }

    renderOption(data: Array<any>) {
        return data.map((s, idx) =>
                        <option key = {'filter_' + idx}
                                value = {idx}> {s.status} ({s.number}) </option>
                        );
        }

    }
